import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  template: `
    <app-header />
    <main class="shell-content">
      <router-outlet />
    </main>
    <app-footer />
  `,
  styles: [`
    .shell-content {
      padding-top: calc(56px + env(safe-area-inset-top));
      padding-bottom: calc(64px + env(safe-area-inset-bottom));
      min-height: 100dvh;
      background: var(--bg);
    }
  `],
})
export class ShellComponent {}
